<template>
  <div class="text-center body">
      <div class="form-login">
        <img src="../assets/logo_black.png">
        <h3 class="pb-2">
          {{ $t("login.subTitle") }}
        </h3>
        
      <form class="border bg-light p-3" @submit.prevent="login" novalidate>
            <div class="pb-2" v-if="isLoginError">
              <label class="text-danger">{{ $t("login.loginError") }}</label>
              <p class="text-danger">{{ $t("login.loginErrorPre") }}</p>
            </div>
            <div class="p-2">
          <input type="email" class="form-control" id="email" v-model="loginForm.email_address" :placeholder="$t('common.email')" required>
            </div>
            <div class="p-2">
          <input type="password" class="form-control" id="current-password" v-model="loginForm.password" :placeholder="$t('common.password')" required>
            </div>
            <div class="d-grid gap-2 p-2 mt-2">
              <button type="submit" class="btn btn-primary" :disabled="isButtonDisabled">{{ $t("login.login") }}</button>
            </div>
          </form>

          <ul class="nav flex-column p-3">
            <li class="pb-1">
              <router-link to="/forgot">{{ $t("login.forgot") }}</router-link>
            </li>
            <li class="pb-1">
              <router-link to="/provisionalEntry">{{ $t("login.signUp") }}</router-link>
            </li>
          </ul>
          <div class="border rounded bg-danger w-100" v-show="isTokenErrorMessage">
            <label class="text-danger text-light p-2">{{ $t("error.invalidToken") }}</label>
          </div>
      </div>
  </div>
</template>

<script>
import axios from 'axios'
import Const from '../const'
import reCaptchaMixin from "../mixins/reCaptchaMixin";

export default {
  mixins: [reCaptchaMixin],
  data() {
    return {
      loginForm: { email_address: "", password: "" },
      isLoginError: false,
      isTokenErrorMessage: false,
      isButtonDisabled: false
    }
  },
  methods: {
    async login() {
      this.isButtonDisabled = true
      this.isLoginError = false
      this.isTokenErrorMessage = false

      if (!this.loginForm.email_address || !this.loginForm.password) {
        this.isButtonDisabled = false
        return
      }

      // reCaptchaからトークンを取得
      try {
        this.loginForm["recaptcha_token"] = await this.getRecaptchaToken()
      } catch (error) {
        this.postResult = "error"
        this.isButtonDisabled = false;
        return
        }

      try {
        const headers = { "Content-Type": "application/json" }
        const response = await axios.post(Const.BASE_URL + '/user-login', this.loginForm, { headers })
        // ログインユーザー情報を保存
        const data = response.data
        this.$store.dispatch('updateToken', data.token)
        this.$store.dispatch('updatePersonalName', data.name)
        this.$store.dispatch('updateLoginFlag', true)
        // 画面遷移
        this.$router.push({ name: "roomList" })
      } catch (error) {
        console.error('[LoginForm] login error:', error?.response?.status, error?.response?.data, error?.message)
        this.isLoginError = true
      }
        this.isButtonDisabled = false
    }
  },
  created() {
    if (this.$store.getters.isTokenError) {
      this.isTokenErrorMessage = true
      this.$store.dispatch("clearTokenError")
    } else {
      this.isTokenErrorMessage = false
    }
    this.$store.dispatch("clearAll")
  }
}
</script>

<style scoped>
.body {
  display: flex;
  height: 100%;
  padding-top:128px;
  padding-bottom: 40px;
}
.form-login {
  width: 100%;
  max-width: 330px;
  padding: 15px;
  margin: auto;
}

.form-login img{
  width: 100%;
  padding-bottom: 0.5rem;
}

.text-danger {
  margin: 0;
}
.price-a {
  text-align: left;
  bottom: 50px;
  right: 10px;
  background-color: #ff446a;
  color: white;
}
</style>
